const state = {
  isCollapse: false
};

const mutations = {
  SET_COLLAPSE: state => {
    state.isCollapse = !state.isCollapse;
  }
};

const actions = {
  changeIsCollapse({ commit }) {
    commit("SET_COLLAPSE");
  }
};

export default {
  state,
  mutations,
  actions
};
